export default __webpack_public_path__ + "static/media/TTT_login_preview.59e9fbbc.jpg";